import React, { useState, useEffect } from 'react';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { fetchPaginatedUsers } from '../services/api';
import PaginationComponent from '../components/PaginationComponent';

function PaginatedUserList() {
    const { pageNumber } = useParams();
    const navigate = useNavigate();
    const [users, setUsers] = useState([]);
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(pageNumber ? parseInt(pageNumber) : 1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        setIsLoading(true);
        fetchPaginatedUsers(currentPage, 20)
            .then(data => {
                setUsers(data.accounts);
                setTotalPages(data.totalPages);
                setIsLoading(false);
            })
            .catch(err => {
                console.error('Failed to fetch users:', err);
                setError('Failed to fetch users');
                setIsLoading(false);
            });
    }, [currentPage]);

    useEffect(() => {
        if (pageNumber) {
            setCurrentPage(parseInt(pageNumber));
        }
    }, [pageNumber]);

    const handlePageChange = (pageNumber) => {
        navigate(`/users/${pageNumber}`);
    };

    if (isLoading) {
        return <div className="container mt-3"><h1>Loading...</h1></div>;
    }

    if (error) {
        return <div className="alert alert-danger" role="alert">{error}</div>;
    }

    if (users.length === 0) {
        return <div className="container mt-3">No Users Found</div>;
    }

    return (
        <div className="container mt-3">
            <div className='page-header'>
                <h1 className='gradient-under'>User List</h1>
            </div>

            <table className="table">
                <thead>
                    <tr>
                        <th>NetID</th>
                        <th>Name</th>
                        <th>Department</th>
                        <th>Details</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map(user => (
                        <tr key={user.netId}>
                            <td>{user.netId}</td>
                            <td>{user.firstName} {user.lastName}</td>
                            <td>{user.department}</td>
                            <td><Link to={`/user/${user.netId}`}>View Details</Link></td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <PaginationComponent currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
        </div>
    );
}

export default PaginatedUserList;
